/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template_update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsResult,
} from "./types";

export const postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTags = reactQueryMutationAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsCacheKeys,
  ({
    appGroupId,
    desiredState,
  }: PostEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsProps): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsResult> => {
    // manipulate props here as needed desiredState
    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_template_update_tags`,
      "POST",
      {
        desired_state: desiredState,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
